import React from 'react';
import { Card } from 'react-bootstrap';
import AvatarCircle from 'app/components/AvatarCircle';
import SampleAvatarImage from 'resources/images/sample-avatar-image.png';
import { getScoreSpan } from 'app/containers/WeeklyCheckInMonitor/helpers';
import { WEEKLY_CHECK_IN_FEATURE_NAME } from 'app/containers/WeeklyCheckInMonitor/constants';
import { getOutOfFiveColor } from 'app/containers/Dashboard/helpers';

const EmployeeConversationSummaryReport: React.FC = () => {
  return (
    <Card className="padding-20px column-gap-20px">
      <p className="m-0 date-subtitle">Jordan Kim's 05/29 Check-in</p>
      <hr className="m-0" />
      <p>Check-In completed by</p>
      <div className="row-gap-8px">
        <AvatarCircle name="Jordan Kim" profilePicture={SampleAvatarImage} />
        <div>
          <p className="fw-bold">Jordan Kim</p>
          <p className="small-grey-text">Operations Manager</p>
        </div>
      </div>
      <div className="row-gap-16px">
        {getScoreSpan("Mood score", 3)}
        {getScoreSpan("Progress score", 4)}
        {getScoreSpan("Readiness score", 3)}
      </div>

      <div className="column-gap-16px">
        <div className="column-gap-4px">
          <p className="grey-text">Response Summary:</p>
          <p>
            Successfully reduced shipping errors by 35% through new quality
            control process while managing staffing shortage after two team
            members gave notice unexpectedly.
          </p>
        </div>
        <div className="column-gap-4px">
          <p className="grey-text">More Insights:</p>
          <p>
            Concerned about maintaining service levels during upcoming busy
            season with reduced headcount. Also dealing with vendor price
            increases affecting budget projections.
          </p>
        </div>
        <div className="column-gap-4px">
          <p className="grey-text">Win Spotlight:</p>
          <ul className="check-in-response-list">
            <li>
              Achievement: Implemented new QC checklist that caught 47 errors
              before shipment this week
            </li>
            <li>
              Impact: Saved approximately $12K in return shipping costs and
              protected customer satisfaction scores
            </li>
            <li>
              Recognition: Recognize the proactive problem-solving and team
              training effort
            </li>
          </ul>
          <div className="d-flex">
            <div className={`out-of-5-span-tag ${getOutOfFiveColor(8 / 2)}`}>
              <p>Magnitude: 8 out of 10</p>
            </div>
          </div>
        </div>
        <div className="column-gap-4px">
          <p className="grey-text">Issue Spotlight:</p>
          <ul className="check-in-response-list">
            <li>
              Issue: Two experienced team members leaving with only 2 weeks to
              hire and train replacements before peak season
            </li>
            <li>
              Impact: Risk of overtime costs, service delays, and remaining
              team burnout
            </li>
            <li>
              Action: Fast-track hiring process and explore temporary staffing
              options
            </li>
          </ul>
          <div className="d-flex">
            <div
              className={`out-of-5-span-tag ${getOutOfFiveColor(
                7 / 2,
                true
              )}`}
            >
              <p>Severity: 7 out of 10</p>
            </div>
          </div>
        </div>
        <Card
          className="column-gap-4px"
          style={{
            backgroundColor: "#F5F7FC",
            padding: "16px 24px",
          }}
        >
          <p className="grey-text">Conversation Starters:</p>
          <ul className="check-in-response-list">
            <li>
              What specific skills or experience are most critical in the team
              members we need to replace quickly?
            </li>
            <li>
              How can we adjust the workflow to protect the remaining team
              from burnout while maintaining quality standards?
            </li>
            <li>
              Given the vendor price increases, what cost-saving opportunities
              have you identified that won't impact service quality?
            </li>
          </ul>
        </Card>
      </div>
      <p className="grey-text">
        This {WEEKLY_CHECK_IN_FEATURE_NAME} was completed on 5/29/2025
      </p>
    </Card>
  );
};

export default EmployeeConversationSummaryReport;
